module.exports = __webpack_public_path__ + "img/about-1.d6816ab.jpg";